import { render, staticRenderFns } from "./alt-badge.vue?vue&type=template&id=0af33076&"
import script from "./alt-badge.vue?vue&type=script&lang=ts&"
export * from "./alt-badge.vue?vue&type=script&lang=ts&"
import style0 from "./alt-badge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports